<template>
  <div class="batch-summary-header m-4">
    <div class="row w-100">
      <div
        class="col-3 d-flex flex-column justify-content-center"
        style="width: 244px"
      >
        <div class="batch-summary-label">Date & Time</div>
        <div class="batch-summary-label summary-text">{{ dateTime }}</div>
      </div>
      <div
        class="col-3 d-flex flex-column justify-content-center"
        style="width: max-content"
      >
        <div class="batch-summary-label">Total Amount (Include Admin Fee)</div>
        <div class="batch-summary-label summary-text">
          {{ formattedTotalAmount }}
        </div>
      </div>
      <div
        class="col-3 d-flex flex-column justify-content-center"
        style="width: 244px"
      >
        <div class="batch-summary-label">Total Admin Fee</div>
        <div class="batch-summary-label summary-text">
          {{ formattedAdminFee }}
        </div>
      </div>
      <div
        class="col-3 d-flex flex-column justify-content-center"
        style="width: 244px"
      >
        <div class="batch-summary-label">Status</div>
        <span :class="['status-badge', statusClass(overallStatus)]">{{
          overallStatus
        }}</span>
      </div>
    </div>

    <div class="row w-100 mt-2 d-flex gap-2">
      <div class="summary-badge">
        <div class="summary-badge-title">Success Rate</div>
        <div class="summary-badge-value">{{ successRate }}%</div>
      </div>
      <div class="summary-badge">
        <div class="summary-badge-title">Total Entries</div>
        <div class="summary-badge-value">{{ totalEntries }}</div>
      </div>
      <div class="summary-badge">
        <div class="summary-badge-title d-flex gap-1 align-items-center">
          <img
            src="../../../public/assets/icons/ic_success.png"
            alt="Logo"
            width="24px"
            height="24px"
          />
          <div style="color: #128050">Success</div>
        </div>
        <div class="summary-badge-value">{{ successCount }}</div>
      </div>
      <div class="summary-badge">
        <div class="summary-badge-title d-flex gap-1 align-items-center">
          <img
            src="../../../public/assets/icons/ic_failed.svg"
            alt="Logo"
            width="24px"
            height="24px"
          />
          <div style="color: #5b1718">Failed</div>
        </div>
        <div class="summary-badge-value">{{ failedCount }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from "@/utils/param-utils.js"; // Import formatNumber

export default {
  name: "BatchSummaryComponent",
  components: {},
  props: {
    dateTime: {
      type: String,
      required: true,
      default: "15/01/25, 13:12", // Default from image
    },
    totalAmount: {
      type: String,
      required: true,
      default: "IDR 0", // Default from image
    },
    adminFee: {
      type: String,
      required: true,
      default: "IDR 0", // Default from image
    },
    overallStatus: {
      type: String,
      required: true,
      default: "Partial Success", // Default from image
    },
    successRate: {
      type: Number,
      required: true,
      default: 0, // Default from image
    },
    totalEntries: {
      type: Number,
      required: true,
      default: 0, // Default from image
    },
    successCount: {
      type: Number,
      required: true,
      default: 0, // Default from image
    },
    failedCount: {
      type: Number,
      required: true,
      default: 0, // Default from image
    },
  },
  computed: {
    formattedTotalAmount() {
      return `IDR ${formatNumber(this.totalAmount)}`;
    },
    formattedAdminFee() {
      return `IDR ${formatNumber(this.adminFee)}`;
    },
  },
  methods: {
    statusClass(status) {
      switch (status.toLowerCase()) {
        case "success":
          return "success";
        case "failed":
          return "failed";
        case "partial success":
          return "partial-success";
        default:
          return "";
      }
    },
  },
};
</script>

<style scoped>
.status-badge {
  padding: 4px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
  text-align: center;
  width: fit-content;
}

.summary-badge {
  width: 250px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 8px 24px 8px 16px;
  border-radius: 100px;

  background: var(--Dark-White, #ffffff);
  border: 1px solid var(--Background-Grey, #dae0e2);
}

.summary-badge-title {
  font-family: "IBM Plex Sans Devanagari", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75%;
  color: var(--Dark-50, #7c8c8d);
}

.summary-badge-value {
  font-family: "IBM Plex Sans Devanagari", sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0%;
  color: #022326;
}

.summary-text {
  font-family: "IBM Plex Sans Devanagari", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.75%;
  color: #022326;
}

.status-badge.success {
  background-color: #dcfce7;
  color: #15803d;
}

.status-badge.failed {
  background-color: #fee2e2;
  color: #dc2626;
}

.status-badge.partial-success {
  background-color: #fff7ed;
  color: #ea580c;
}
</style>
